import React, { useContext, useEffect, useState } from "react";
import Billing from "./Billing";
import { DataContext } from "../../../Context/DataContext";
import { AuthContext } from "../../../Context/AuthContext";
import { NotificationContext } from "../../../Context/NotificationContext";

import { ReactComponent as EditIcon } from "../../../assets/icons/Edit-black.svg";
import PAYPAL from "../../../assets/icons/paypal.png";
import { ReactComponent as PAYPALICON } from "../../../assets/icons/paypal_logo.svg";
import { ReactComponent as PAYPALLOGO } from "../../../assets/icons/PayPal-Orange.svg";
import { ReactComponent as TRASH } from "../../../assets/icons/Trash.svg";
import CARDICON from "../../../assets/icons/CardBlue.png";

import BillingPeriodPopUp from "./BillingPeriodPopUp";
import "./Billing.css";

import { AccountType } from "../../../utility/enums";
import PayPalBilling from "./PayPalBilling";
import PaymentApproach from "./PaymentApproach";
import { firestore } from "../../../firebase.config";
import { Elements } from "@stripe/react-stripe-js";
import ElementsWrapper from "../../../NewComponents/ElementsWrapper";

const AccountBilling = ({ windowSize }) => {
  const { userData, teamData } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);

  const [paymentCardId, setPaymentCardId] = useState("");
  const [cardName, setCardName] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [defaultCard, setDefaultCard] = useState("");
  const [cardsList, setCardsList] = useState([]);

  const [selectedPaymentType, setSelectedPaymentType] = useState("card");
  const [pendingInvoices, setPendingInvoices] = useState(true);
  
  useEffect(() => {
    if (signedIn && userData) {
      const billingData = userData.teamId && teamData ? teamData : userData;
      const defaultCard =
        billingData.paymentMethods?.find((card) => card.default) || null;
      setDefaultCard(defaultCard ? defaultCard.id : null);
    }
  }, [signedIn, userData, teamData]);


  useEffect(() => {
    if(userData && userData.teamId && teamData && teamData.billingTerm && teamData.billingTerm !== "case-by-case") {
      checkPendingInvocies();
    }else{
      setPendingInvoices(false);
    }
  }, [userData, teamData])



  const checkPendingInvocies = async() => {
    await firestore.collection("orderInvoices").where("teamId", "==", userData.teamId).where("status", "==", "pay-later").where("type", "==", "multipleInvoice").get()
    .then((snapshot) => {
      if(snapshot.empty) return setPendingInvoices(false);
      else {
        setPendingInvoices(true);
      }
    })
  }

  return (
    <div className="accountSettingShippingWrap">

      {signedIn && userData && userData.teamId && teamData && (
        <PaymentApproach defaultCard={defaultCard} pendingInvoices={pendingInvoices} />
      )}
      <h4 className="quotePrimaryTitle">Payment Methods</h4>
      <div className="grid grid-cols-2 md:gap-2 gap-4 md:w-fit w-full">
        <div
          className={`caseByCaseBtn md:w-fit w-full billingPeriodBtn ${selectedPaymentType === "card" && "selectedBillingTerm"
            }`}
          onClick={() => setSelectedPaymentType("card")}
        >
          <img className="orderPaypalIcon" src={CARDICON} alt="card" />
          Card
        </div>
        <div
          className={`caseByCaseBtn md:w-fit w-full billingPeriodBtn ${selectedPaymentType === "paypal" && "selectedBillingTerm"
            }`}
          onClick={() => setSelectedPaymentType("paypal")}
        >
          <img className="orderPaypalIcon" src={PAYPAL} alt="card" />
        </div>
      </div>

      {selectedPaymentType === "card" && (
        <ElementsWrapper>
          <Billing
            type="save"
            setDefaultCard={setDefaultCard}
            setSelectedCard={setPaymentCardId}
            selectedCard={paymentCardId}
            setCardOwner={setCardName}
            cardOwner={cardName}
            saveCard={saveCard}
            setSaveCard={setSaveCard}
            cardsList={cardsList}
            setCardsList={setCardsList}
            windowSize={windowSize}
            pendingInvoices={pendingInvoices}
          />
        </ElementsWrapper>
      )}

      {selectedPaymentType === "paypal"  && (
        <PayPalBilling userData={userData} />
      )}
    </div>
  );
};

export default AccountBilling;
